// removed by extract-text-webpack-plugin
module.exports = {"TimePicker":"TimeSwitch__TimePicker__3vUBW","TimeSwitch":"TimeSwitch__TimeSwitch__33-W5","SwitchIcon":"TimeSwitch__SwitchIcon__2gRnf","SwitchIconLeft":"TimeSwitch__SwitchIconLeft__2PaUM","SwitchIconRight":"TimeSwitch__SwitchIconRight__aaQig","NotActiveText":"TimeSwitch__NotActiveText__yHUoR","ActiveText":"TimeSwitch__ActiveText__3pjfW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TimePicker/TimeSwitch/TimeSwitch.css
// module id = 191
// module chunks = 0